module.exports = __webpack_public_path__ + "static/media/CA-short.ecdfeada.svg";